import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Page } from '../page.model';
import {
  Client,
  ClientDetail,
  ClientStatistics,
  ClientStatus,
  CreateClientPayload,
  UpdateClientPayload,
} from './client.models';

export interface ClientFilters {
  status?: ClientStatus | null;
  q?: string | null;
  page?: number;
  size?: number;
}

@Injectable({ providedIn: 'root' })
export class ClientService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  private base(): string {
    return `/api/t/${this.auth.currentTenant()}/clientes`;
  }

  list(filters: ClientFilters = {}): Observable<Page<Client>> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return this.http.get<Page<Client>>(this.base(), { params });
  }

  get(id: number): Observable<ClientDetail> {
    return this.http.get<ClientDetail>(`${this.base()}/${id}`);
  }

  create(payload: CreateClientPayload): Observable<Client> {
    return this.http.post<Client>(this.base(), payload);
  }

  update(id: number, payload: UpdateClientPayload): Observable<Client> {
    return this.http.put<Client>(`${this.base()}/${id}`, payload);
  }

  statistics(): Observable<ClientStatistics> {
    return this.http.get<ClientStatistics>(`${this.base()}/estatisticas`);
  }
}
